// The DELTA chip of a home widget (HOME_WIDGETS_SPEC.md §2): a `layer`
// capsule with a status dot and a mono value — "↑ 12% · 7d".
//
//   HomeWidgetDelta: {
//     Text: { text: (el, s) => el.call('biDeltaLabel', s.root) },
//     bad: (el, s) => el.call('biDeltaIsDown', s.root),   // red dot
//     hide: (el, s) => !el.call('biHasComparison', s.root)
//   }
//
// The dot takes the widget hue for a trend and `dangerInk` only when the
// message is bad (overdue, low, out). With no comparison the body hides the
// chip — never a fake "0%".
export const HomeWidgetDelta = {
  tag: 'span',
  class: 'home-widget-delta',
  gridArea: 'delta',
  display: 'flex',
  alignItems: 'center',
  gap: 'X2',
  justifySelf: 'start',
  alignSelf: 'start',
  width: 'fit-content',
  maxWidth: '100%',
  padding: 'W2 Y1',
  round: 'radiusPill',
  theme: 'layer',
  bad: false,

  Dot: {
    tag: 'span',
    'aria-hidden': 'true',
    boxSize: 'Y',
    flexShrink: '0',
    round: 'radiusPill',
    background: (el) => (el.parent.bad ? 'dangerInk' : '--home-widget-accent')
  },

  Text: {
    tag: 'span',
    fontFamily: 'Code',
    fontSize: 'Y',
    lineHeight: '1.4',
    fontVariantNumeric: 'tabular-nums',
    color: 'caption',
    whiteSpace: 'nowrap',
    minWidth: '0',
    overflow: 'hidden',
    // secondary text: an ellipsis is allowed only with the full text in `title`
    textOverflow: 'ellipsis',
    title: (el) => el.call('homeSlotText', el) || null
  }
}
